import { render, staticRenderFns } from "./WelcomeErrorPage.vue?vue&type=template&id=366a217b&scoped=true"
import script from "./WelcomeErrorPage.vue?vue&type=script&lang=ts"
export * from "./WelcomeErrorPage.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeErrorPage.vue?vue&type=style&index=0&id=366a217b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a217b",
  null
  
)

export default component.exports